/**
 * Quantity clamping for the booking stepper. `max` is the units actually
 * available for the selected dates (the range availability call's `remaining`).
 * Returns 0 only when there is no availability (max 0); otherwise a whole
 * number in 1..max. The stepper and price math both trust this as the cap, so
 * a customer can never request more boards than exist on those dates.
 */
export function clampQty(desired: number, max: number): number {
  if (max <= 0) return 0
  const whole = Math.floor(desired)
  if (whole < 1) return 1
  if (whole > max) return max
  return whole
}
